// Module
var code = "<div ui-view class=default-abstract-ui-view></div>";
// Exports
module.exports = code;